module.exports = __webpack_public_path__ + "img/JJKJ.1e5cda37.png";